import React from 'react';

const ExperienceContent = ({ title, description, details, imageSrc, pricing, depositInfo }) => {
  return (
    <div style={{ animation: 'fadeIn 0.5s ease-in' }}>
      <div className="grid-two-column">
        <div>
          <img 
            src={imageSrc}
            alt={title}
            style={{ 
              width: '100%', 
              height: 'auto',
              display: 'block'
            }}
          />
        </div>
        <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
          <h2 className="hero-medium" style={{ marginBottom: '24px' }}>
            {title}
          </h2>
          <p className="body-large" style={{ marginBottom: '20px', lineHeight: '1.8' }}>
            {description}
          </p>
          <p className="body-large" style={{ marginBottom: '32px', lineHeight: '1.8', color: 'var(--text-secondary)' }}>
            {details}
          </p>

          {pricing}

          {depositInfo && (
            <div style={{ 
              padding: '20px 24px',
              background: 'rgba(90, 30, 43, 0.05)',
              borderLeft: '3px solid var(--burgundy)'
            }}>
              <p className="body-small" style={{ marginBottom: '12px', lineHeight: '1.7', fontWeight: '500' }}>
                {depositInfo.message}
              </p>
              <p className="body-small" style={{ margin: 0, lineHeight: '1.6' }}>
                <strong>Beem: @honeysofia</strong> — {depositInfo.details}
              </p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ExperienceContent;
